import { Reducer } from 'redux';
import { CurrentUserState, CurrentUserActionTypes } from './types';

// 初期状態
export const initialState: CurrentUserState = null

const reducer: Reducer<CurrentUserState> = (
  state: CurrentUserState = initialState,
  action,
): CurrentUserState => {
  switch (action.type) {
    case CurrentUserActionTypes.UPDATE: {
      const newState: CurrentUserState = action.payload;
      return newState;
    }
    default:
      return state;
  }
};

export { reducer as currentUserReducer };
